const KEY='event-platform.active-event';
export const eventWorkspaceStorage={
 get:()=>{try{return localStorage.getItem(KEY)}catch{return null}},
 set:(eventId:string)=>{try{localStorage.setItem(KEY,eventId)}catch{/* storage unavailable */}},
 clear:()=>{try{localStorage.removeItem(KEY)}catch{/* storage unavailable */}}
};
